module.exports = __webpack_public_path__ + "static/media/logo_zf.9b726140.svg";